export default __webpack_public_path__ + "static/media/step3.21e507fb.png";